<template>
    <div style="display: flex; flex-direction: column; font-weight: 500;">
        <div style="position: relative; border-bottom: 1px solid #f5f5f5;">
            <RecommendationHeader subTitle="프로필" title="프로필 수정"></RecommendationHeader>
        </div>
        <div style="flex: 1; overflow-y: scroll; font-weight: 500; padding: 0 12px; padding-bottom: 40px;">
            <div style="font-size: 14px; font-weight: 700; margin-top: 20px;">프로필 이미지</div>
            <div style="margin-top: 8px; text-align: center; position: relative;">
                <ProfileImage style="width: 90px;" :imagePath="memberInfo.image_path" :is-show-border="false"></ProfileImage>
                <div @click="showPopMenu(); $Util.sendEventClick('마이페이지_프로필수정_프로필이미지변경')" style="margin-top: 8px; font-size: 12px; color: var(--color-main);">프로필 이미지 변경</div>
                <input type="file" style="display:none;" accept="image/*" @change="readURL($event)" ref="imageFile">
            </div>
            <div style="margin: 40px 0;">
                <div style="display: flex; justify-content: space-between;">
                    <div style="font-weight: 700; font-size: 14px;">{{ isCoach ? '이름' : '닉네임' }}</div>
                    <div v-if="!isCoach" @click="setIsOpenSettingProfileName(); $Util.sendEventClick('마이페이지_프로필수정_닉네임변경')" style="font-weight: 500; font-size: 14px; color: var(--color-main);">변경</div>
                </div>
                <div style="font-weight: 700; font-size: 14px; line-height: 24px; margin-top: 8px;" class="common_box">{{ isCoach ? memberInfo.name : memberInfo.nic_name }}</div>
            </div>
            <div style="margin-bottom: 40px;">
                <div style="display: flex; justify-content: space-between;">
                    <div style="font-weight: 700; font-size: 14px;">자기소개</div>
                    <div @click="setIsOpenSettingProfileIntro(); $Util.sendEventClick('마이페이지_프로필수정_자기소개변경')" style="font-weight: 500; font-size: 14px; color: var(--color-main);">편집</div>
                </div>
                <div style="font-size: 14px; line-height: 24px; margin-top: 8px;" class="common_box">{{ memberInfo.introduce === null ? '없음' : memberInfo.introduce }}</div>
            </div>
            <div v-if="memberInfo.is_temp_coach === '1'">
                <div style="display: flex; justify-content: space-between;">
                    <div style="font-weight: 700; font-size: 14px;">인터뷰 및 홍보 영상</div>
                    <div @click="setIsOpenSettingMedia(); $Util.sendEventClick('마이페이지_프로필수정_인터뷰영상변경')" v-if="media && media.media_path" style="font-weight: 500; font-size: 14px; color: var(--color-main);">편집</div>
                </div>
                <div v-if="media && media.media_path" style="border-radius:12px; overflow:hidden; margin-bottom: 40px; margin-top: 8px;">
                    <template v-if="$Util.checkYoutubeLink(media.media_path)">
                        <ContentsViewer :contents="media.media_path" />
                    </template>
                    <template v-else>
                        <img :src="$resourcePath + media.media_path" style="width:100%;" />
                    </template>
                </div>
                <div @click="setIsOpenSettingMedia(); $Util.sendEventClick('마이페이지_프로필수정_미디어변경')" style="margin-top: 8px; margin-bottom: 40px; text-align: center;" class="common_box" v-else>
                    <div>
                        <img style="width: 40px;" :src="require('@/assets/img/no_media.png')" alt="">
                    </div>
                    <div style="font-weight: 700; font-size: 14px; line-height: 24px; margin-top: 12px; color: var(--color-main);">미디어 추가하기</div>
                </div>
            </div>
            <div>
                <div style="margin-bottom: 20px;">
                    <div style="font-weight: 700; font-size: 14px; line-height: 24px;">프로필 박스</div>
                    <div style="font-weight: 500; font-size: 12px; line-height: 20px; color: #606060;">프로필 박스는 축구를 하는 회원님의 모습을 가장 잘 표현할 수 있는 방법입니다. 사커하우 커뮤니티에서 회원님의 이용 목적 혹은 관심사와 비슷한 콘텐츠 제공 받아볼 수 있으며, 이용목적에 따라 축구 전문가들에게 직접적인 도움을 받을 수 있습니다.</div>
                </div>
                <div style="display: grid;grid-template-columns: 1fr 1fr 1fr;gap: 12px;">
                    <!-- <div @click="showSelectPosition(false)" style="padding-bottom: 16px; position: relative;margin-bottom: 24px;" :class="isPositionBox" class="profile_box">
                        <div style="padding-top: 25px; position: relative">
                            <object :data="isPositionImg" type=""></object>
                        </div>
                        <div style="font-size: 12px; font-weight: 700;" :class="isPositionText">{{ memberInfo.position ? memberInfo.position : '포지션' }}</div>
                        <div style="text-align: center; bottom: -24px; position: absolute; line-height: 20px; font-size: 12px; margin-top: 4px; color: var(--color-main);">{{ memberInfo.position ? '수정하기' : '설정하기' }}</div>
                    </div> -->
                    <div @click="setIsOpenSettings(each.name, false);" style="position: relative; margin-bottom: 24px;" v-for="each, i in myProfileBoxList" :key="i" class="profile_box">
                        <div style="padding-top: 20px;">
                            <object v-if="each.name !== PROFILE_BOX_LIST.FOOT_WAY" :data="each.isComplete || each.name === PROFILE_BOX_LIST.SEX || each.name === PROFILE_BOX_LIST.VISIT_REASONS || each.name === PROFILE_BOX_LIST.CAREER ? require(`@/assets/images/mypage/profile_box_${each.name}.svg`) : require(`@/assets/images/mypage/profile_box_gray_${each.name}.svg`)" type=""></object>
                            <object v-else-if="each.name === PROFILE_BOX_LIST.FOOT_WAY" :data="getFootImage(memberInfo.foot_way)" type=""></object>
                            <!-- <object v-else-if="each.name === 'star'" :data="getFootImage(memberInfo.foot_way)" type=""></object> -->
                        </div>
                        <div v-if="isShowBoxText" :style="{ color: each.isComplete ? '' : '#808080' }" style="font-size: 12px; font-weight: 700; text-align: center; line-height: 16px;">{{ transText(each.name) }}</div>
                        <div v-if="each.name !== PROFILE_BOX_LIST.AGE_RANGE && each.name !== PROFILE_BOX_LIST.SEX" style="text-align: center; bottom: -24px; position: absolute; line-height: 20px; font-size: 12px; margin-top: 4px; color: var(--color-main);">{{ each.isComplete ? '수정하기' : '설정하기' }}</div>
                        <div v-else style="text-align: center; line-height: 20px; font-size: 12px; bottom: -24px; margin-top: 4px; color: #d9d9d9; position: absolute;">변경 불가</div>
                    </div>
                </div>
                <div style="margin-top: 40px;">
                    <div class="alarm_container">
                        <div style="flex:1;">
                            <div class="alarm_container_title">나이대 표시</div>
                            <div class="alarm_container_explanation">프로필 박스에 나이대를 표시합니다</div>
                        </div>
                        <div style="display:grid; place-items: center;">
                            <CustomSwitchFilter v-model="settings.age_range" :click-action="() => { saveIsShowToggleInfo('age_range') }" :isBold="true" />
                        </div>
                    </div>
                    <div style="margin-top: 12px;" class="alarm_container">
                        <div style="flex:1;">
                            <div class="alarm_container_title">성별 표시</div>
                            <div class="alarm_container_explanation">프로필 박스에 성별을 표시합니다</div>
                        </div>
                        <div style="display:grid; place-items: center;">
                            <CustomSwitchFilter v-model="settings.sex" :click-action="() => { saveIsShowToggleInfo('sex') }" :isBold="true" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <SettingPlace :isOpen="settingsArray[0].isOpenSettingPlace" :closeCompleteAction="setIsOpenSettings"></SettingPlace>
        <SettingDisplayTag :isOpen="settingsArray[3].isOpenSettingUseReason" :closeCompleteAction="setIsOpenSettings"></SettingDisplayTag>
        <SettingUseReason :isOpen="settingsArray[2].isOpenSettingUseReason" :closeCompleteAction="setIsOpenSettings"></SettingUseReason>
        <SettingHeight :isOpen="settingsArray[4].isOpenSettingHeight" :closeCompleteAction="setIsOpenSettings"></SettingHeight>
        <SettingFootWay :isOpen="settingsArray[5].isOpenSettingFootWay" :closeCompleteAction="setIsOpenSettings"></SettingFootWay>
        <SettingSpecialSkill :isOpen="settingsArray[6].isOpenSettingSpecialSkill" :closeCompleteAction="setIsOpenSettings"></SettingSpecialSkill>
        <SettingPlayStyle :isOpen="settingsArray[7].isOpenSettingPlayStyle" :closeCompleteAction="setIsOpenSettings"></SettingPlayStyle>
        <SettingVisitReason :isOpen="settingsArray[9].isOpenSettingVisitReason" :closeCompleteAction="setIsOpenSettings"></SettingVisitReason>
        <SettingLicense :isOpen="settingsArray[8].isOpenSettingLicense" :closeCompleteAction="setIsOpenSettings"></SettingLicense>
        <SettingCareer :isOpen="settingsArray[10].isOpenSettingCareer" :closeCompleteAction="setIsOpenSettings"></SettingCareer>
        <SettingExpertInfo :isOpen="settingsArray[11].isOpenSettingExpertInfo" :closeCompleteAction="setIsOpenSettings"></SettingExpertInfo>
        <SettingProfileName :isOpen="isOpenSettingProfileName" :closeCompleteAction="closeSettingProfileName"></SettingProfileName>
        <SettingProfileIntro :isOpen="isOpenSettingProfileIntro" :closeCompleteAction="closeSettingProfileIntro"></SettingProfileIntro>
        <SettingMedia :isOpen="isOpenSettingMedia" :closeCompleteAction="closeSettingMedia"></SettingMedia>
        <SettingPosition :isOpen="isOpenSettingPosition" :closeCompleteAction="closeSettingPosition"></SettingPosition>
        <EditModalFrame v-if="myPosition" :isOpen="selectDefaultImage" :closeModal="cancel" title="기본 이미지">
            <div style="display: flex; align-items: center; margin-top: 40px; font-weight: 500; text-align: center; justify-content: center; font-size: 14px;">
                <div style="color: #606060; margin-bottom: 10px; line-height: 24px;">회원님이 찾은 {{ memberInfo.position }} 포지션에 맞는<br>기본 이미지 4장을 준비했습니다.</div>
            </div>
            <div style="margin-top: 32px;">
                <div style="display: flex; justify-content: center; gap: 12px;">
                    <div @click="setDefaultImg('basic')" style="position: relative; text-align:center; border-radius: 50%;">
                        <img :class="defaultImg === 'basic' ? 'select' : ''" style="width: 80px; position: relative; border-radius: 50%; z-index: 2;" :src="require(`@/assets/recommend_profile/basic_profile.png`)" alt="">
                    </div>
                    <div @click="setDefaultImg(index)" style="position: relative; text-align:center; border-radius: 50%;" v-for="each, index in 2" :key="index">
                        <img :class="defaultImg === index ? 'select' : ''" style="width: 80px; position: relative; border-radius: 50%; z-index: 2;" :src="require(`@/assets/recommend_profile/recommend_${myPosition}_${index}.png`)" alt="">
                    </div>
                </div>
                <div style="display: flex; justify-content: center; gap: 12px; margin-top: 12px">
                    <div @click="setDefaultImg(index + 2)" style="position: relative; text-align:center; border-radius: 50%;" v-for="each, index in 2" :key="index">
                        <img :class="defaultImg === index + 2 ? 'select' : ''" style="width: 80px; position: relative; border-radius: 50%; z-index: 2;" :src="require(`@/assets/recommend_profile/recommend_${myPosition}_${index + 2}.png`)" alt="">
                    </div>
                </div>
            </div>
            <div style="margin-top: 40px; display: flex; gap: 12px;">
                <div @click="cancel" class="common_btn cancel">취소하기</div>
                <div @click="apply" :class="defaultImg === 0 || defaultImg ? 'active' : 'un_active'" class="common_btn">적용하기</div>
            </div>
            <!-- <div style="margin-top: 82px">
                <div @click="apply" :style="{ backgroundColor: selectImg === null ? '#f5f5f5' : 'var(--color-main)' }" style="transition: 0.3s all; width: 100%; height: 39px; line-height: 39px; text-align: center; border-radius: 6px; color: #fff">적용하기</div>
                <div @click="cancel" style="text-align: center; margin-top: 10px; font-size: 12px; font-weight: 400; color: #606060; text-decoration: underline;">취소</div>
            </div> -->
        </EditModalFrame>
        <BottomPopupMenu :is-open="isShowPopMenu" :menu-options="popMenuOptions"></BottomPopupMenu>
    </div>
</template>

<script>
import CustomSwitchFilter from '@/components/common/CustomSwitchFilter'
import RecommendationHeader from '@/components/common/RecommendationHeader'
import BottomPopupMenu from '@/components/common/BottomPopupMenu'
import ProfileImage from '@/components/common/ProfileImage'
import { PROFILE_BOX_LIST, PROFILE_FOOT_WAY, IS_COACH } from '@/Constants'
import SettingPlace from '@/components/common/SettingPlace'
import SettingDisplayTag from '@/components/common/SettingDisplayTag'
import SettingUseReason from '@/components/common/SettingUseReason'
import SettingHeight from '@/components/common/SettingHeight'
import SettingFootWay from '@/components/common/SettingFootWay'
import SettingSpecialSkill from '@/components/common/SettingSpecialSkill'
import SettingPlayStyle from '@/components/common/SettingPlayStyle'
import SettingProfileName from '@/components/common/SettingProfileName'
import SettingProfileIntro from '@/components/common/SettingProfileIntro'
import SettingPosition from '@/components/common/SettingPosition'
import SettingVisitReason from '@/components/common/SettingVisitReason'
import SettingLicense from '@/components/common/SettingLicense'
import SettingExpertInfo from '@/components/common/SettingExpertInfo'
import SettingCareer from '@/components/common/SettingCareer'
import SettingMedia from '@/components/common/SettingMedia'
import EditModalFrame from '@/components/modal/my/EditModalFrame'
import ResponseCode from '@/ResponseCode'
import ContentsViewer from "@/components/common/ContentsViewer";

export default {
    name: "MyProfileEdit",
    components: { RecommendationHeader, CustomSwitchFilter, ContentsViewer, SettingMedia, SettingLicense, SettingExpertInfo, SettingCareer, SettingVisitReason, SettingPosition, ProfileImage, BottomPopupMenu, SettingPlace, SettingDisplayTag, SettingUseReason, SettingHeight, SettingFootWay, SettingSpecialSkill, SettingPlayStyle, SettingProfileName, SettingProfileIntro, EditModalFrame },
    props: {
        memberIdx: {
            type: [Number, String],
            default: -1
        },
        completeAction: {
            type: Function,
            default: () => { }
        }
    },
    data() {
        return {
            IS_COACH: IS_COACH,
            settings: {
                sex: true,
                age_range: true
            },
            memberInfo: {},
            isShowBoxText: false,
            myProfileBoxList: [
                // {name: PROFILE_BOX_LIST.POSITION, isComplete: false},
                { name: PROFILE_BOX_LIST.AGE_RANGE, isComplete: false },
                { name: PROFILE_BOX_LIST.SEX, isComplete: false },
                { name: PROFILE_BOX_LIST.HEIGHT, isComplete: false },
                { name: PROFILE_BOX_LIST.FOOT_WAY, isComplete: false },
                { name: PROFILE_BOX_LIST.PLACE_NAME, isComplete: false },
                { name: PROFILE_BOX_LIST.VISIT_REASONS, isComplete: false },
                { name: PROFILE_BOX_LIST.USE_REASONS, isComplete: false },
                { name: PROFILE_BOX_LIST.PLAY_STYLE, isComplete: false },
                { name: PROFILE_BOX_LIST.SPECIAL_SKILL, isComplete: false },
                { name: PROFILE_BOX_LIST.CAREER, isComplete: false },
                // { name: PROFILE_BOX_LIST.DISPLAY_TAG, isComplete: false },
            ],
            PROFILE_BOX_LIST: PROFILE_BOX_LIST,
            settingsArray: [
                { isOpenSettingPlace: false, name: PROFILE_BOX_LIST.PLACE_NAME },
                { isOpenSettingPosition: false, name: PROFILE_BOX_LIST.POSITION },
                { isOpenSettingDisplayTag: false, name: PROFILE_BOX_LIST.DISPLAY_TAG },
                { isOpenSettingUseReason: false, name: PROFILE_BOX_LIST.USE_REASONS },
                { isOpenSettingHeight: false, name: PROFILE_BOX_LIST.HEIGHT },
                { isOpenSettingFootWay: false, name: PROFILE_BOX_LIST.FOOT_WAY },
                { isOpenSettingSpecialSkill: false, name: PROFILE_BOX_LIST.SPECIAL_SKILL },
                { isOpenSettingPlayStyle: false, name: PROFILE_BOX_LIST.PLAY_STYLE },
                { isOpenSettingLicense: false, name: PROFILE_BOX_LIST.LICENSE },
                { isOpenSettingVisitReason: false, name: PROFILE_BOX_LIST.VISIT_REASONS },
                { isOpenSettingCareer: false, name: PROFILE_BOX_LIST.CAREER },
                { isOpenSettingExpertInfo: false, name: PROFILE_BOX_LIST.EXPERT_INFO },
            ],
            isOpenSettingProfileName: false,
            isOpenSettingProfileIntro: false,
            isOpenSettingMedia: false,
            popMenuOptions: {},
            images: [
                { name: '메시', img_path: require('@/assets/img/messi.png'), img_public_path: '/img/messi.png' },
                { name: '말디니', img_path: require('@/assets/img/maldini.png'), img_public_path: '/img/maldini.png' },
                { name: '노이어', img_path: require('@/assets/img/neuer.png'), img_public_path: '/img/neuer.png' },
                { name: '손흥민', img_path: require('@/assets/img/son.png'), img_public_path: '/img/son.png' },
                { name: '라모스', img_path: require('@/assets/img/ramos.png'), img_public_path: '/img/ramos.png' },
                // { name: '케인', img_path: require('@/assets/img/kane.png'), img_public_path: '/img/kane.png' },
            ],
            isShowPopMenu: false,
            selectDefaultImage: false,
            selectImg: null,
            myPosition: null,
            defaultImg: null,
            defaultImgPath: null,
            imagePath: '',
            isOpenSettingPosition: false,
            media: {}
        }
    },
    computed: {
        isPosition() {
            let positionType = '';
            if (this.memberInfo.position === null) {
                positionType = 'no_position'
            } else if (this.memberInfo.is_direct_position == 1) {
                positionType = 'no_position'
            } else if (this.memberInfo.position !== null && this.memberInfo.position_pro_ability === null) {
                positionType = 'position_lite'
            } else if (this.memberInfo.position_pro_ability !== null && this.memberInfo.position !== null) {
                positionType = 'position_pro'
            }
            return positionType
        },
        isPositionBox() {
            let positionType = '';
            if (this.memberInfo.position === null) {
                positionType = ''
            } else if (this.memberInfo.is_direct_position == 1) {
                positionType = ''
            } else if (this.memberInfo.position !== null && this.memberInfo.position_pro_ability === null) {
                positionType = 'profile_box_lite'
            } else if (this.memberInfo.position_pro_ability !== null && this.memberInfo.position !== null) {
                positionType = 'profile_box_pro'
            }
            return positionType
        },
        isPositionImg() {
            let positionType = '';
            if (this.memberInfo.position === null) {
                positionType = require('@/assets/images/mypage/profile_box_gray_position.svg')
            } else if (this.memberInfo.position !== null && this.memberInfo.position_pro_ability === null) {
                positionType = require('@/assets/images/mypage/profile_box_position.svg')
            } else if (this.memberInfo.position_pro_ability !== null && this.memberInfo.position !== null) {
                positionType = require('@/assets/images/mypage/profile_position_pro.svg')
            }
            return positionType
        },
        isPositionText() {
            let positionType = '';
            if (this.memberInfo.position === null) {
                positionType = 'no_position_text'
            } else if (this.memberInfo.position !== null && this.memberInfo.position_pro_ability === null) {
                positionType = ''
            } else if (this.memberInfo.position_pro_ability !== null && this.memberInfo.position !== null) {
                positionType = 'pro_nicname'
            }
            return positionType
        },
        isCoach() {
            if (this.$GlobalStore.loginInfo().is_temp_coach === '1') {
                return true
            } else {
                return false
            }
        }
    },
    methods: {
        closeSettingMedia(isSave) {
            this.isOpenSettingMedia = false
            if (isSave) {
                this.getMemberInfo()
                this.completeAction(true)
            }
        },
        closeSettingPosition(isSave) {
            this.isOpenSettingPosition = false
            if (isSave) {
                this.getMemberInfo()
                this.completeAction(true)
            }
        },
        setDefaultImg(img) {
            if (this.defaultImg === img) {
                this.defaultImg = null
                return
            }
            this.defaultImg = img
            if (img === 'basic') {
                this.defaultImgPath = '/img/recommend_profile/basic_profile.png'
            } else {
                this.defaultImgPath = `/img/recommend_profile/recommend_${this.myPosition}_${img}.png`
            }

        },
        async apply() {
            this.$GlobalStore.showProgress()
            const formData = new FormData
            if (!this.myPosition) {
                this.defaultImgPath = '/img/recommend_profile/basic_profile.png'
            }
            formData.append('img_public_path', this.defaultImgPath);

            const res = await this.$Axios.post('/api/profile/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
            if (res.data.code === ResponseCode.SUCCESS) {
                this.$GlobalStore.hideProgress()
                this.getMemberInfo()
                this.completeAction(true)
                this.$GlobalStore.setLoginInfo(res.data.loginInfo)
                this.defaultImg = null
                this.selectDefaultImage = false
            }
        },
        cancel() {
            this.selectDefaultImage = false
            this.defaultImg = null
        },
        readURL(e) {
            const input = e.currentTarget;
            if (input.files && input.files[0]) {
                var reader = new FileReader();
                reader.onload = () => {
                    this.imagePath = e.target.result
                    this.saveProfileImage();
                }
                reader.readAsDataURL(input.files[0]);
            }
        },
        async saveIsShowToggleInfo(toggleItem) {
            const formData = new FormData()

            if (toggleItem === 'age_range') {
                const ageRangeShow = this.settings.age_range ? 0 : 1
                formData.append('age_range_show', ageRangeShow);
            } else if (toggleItem === 'sex') {
                const sexShow = this.settings.sex ? 0 : 1
                formData.append('sex_show', sexShow);
            }

            const res = await this.$Axios.post('/api/profile/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } });

            if (res.data.code === ResponseCode.SUCCESS) {
                this.getMemberInfo()
                this.completeAction(true, toggleItem)
                this.$GlobalStore.setLoginInfo(res.data.loginInfo)
            }
        },
        async saveProfileImage() {
            this.$GlobalStore.showProgress()
            const formData = new FormData();
            formData.append('imgFile', this.$refs.imageFile.files[0]);

            const res = await this.$Axios.post('/api/profile/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
            if (res.data.code === ResponseCode.SUCCESS) {
                this.$GlobalStore.hideProgress()
                this.getMemberInfo()
                this.completeAction(true)
                this.$GlobalStore.setLoginInfo(res.data.loginInfo)
                this.imagePath = ''
            }
        },
        addFile() {
            this.$refs.imageFile.click();
        },
        showPopMenu() {
            this.isShowPopMenu = true
            this.popMenuOptions = {
                labelAndAction: [
                    {
                        label: '기본 이미지로 설정', action: () => {
                            this.$Util.sendEventClick('마이_프로필수정_기본이미지')
                            if (this.myPosition) {
                                this.selectDefaultImage = true
                            } else {
                                this.apply()
                            }
                            this.isShowPopMenu = false
                        },
                    },
                    {
                        label: '사진에서 선택', action: () => {
                            this.$Util.sendEventClick('마이_프로필수정_앨범선택')
                            this.addFile()
                            this.isShowPopMenu = false
                        },
                    },

                ],
                isExistCancelBtn: true,
                closeAction: () => {
                    this.isShowPopMenu = false
                }
            }
        },
        closeSettingProfileIntro(isSave) {
            this.isOpenSettingProfileIntro = false
            if (isSave) {
                this.getMemberInfo()
                this.completeAction(true)
            }
        },
        setIsOpenSettingProfileIntro() {
            this.isOpenSettingProfileIntro = true
        },
        setIsOpenSettingMedia() {
            this.isOpenSettingMedia = true
        },
        closeSettingProfileName(isSave) {
            this.isOpenSettingProfileName = false
            if (isSave) {
                this.getMemberInfo()
                this.completeAction(true)
            }
        },
        setIsOpenSettingProfileName() {
            this.isOpenSettingProfileName = true
        },
        setIsOpenSettings(name, isClose = false, isComplete, isSave) {
            if (isComplete) {
                return
            }
            if (name === PROFILE_BOX_LIST.POSITION) {
                if (!this.$Util.checkProfileCompleteOrShowRequiredProfile()) return;
                this.showSelectPosition(false)
                return
            }
            const setting = this.settingsArray.find(item => item.name === name);
            if (setting) {
                const key = Object.keys(setting).find(key => key.startsWith('isOpenSetting'));
                if (key) {
                    if (isClose) {
                        setting[key] = false;
                    } else {
                        setting[key] = true;
                    }
                }
            }
            if (isSave) {
                this.getMemberInfo(isSave)
                this.completeAction(true)
            }
        },
        transText(key) {
            switch (key) {
                case PROFILE_BOX_LIST.AGE_RANGE:
                    return this.memberInfo.age_range ? this.memberInfo.age_range : '나이대'
                case PROFILE_BOX_LIST.POSITION:
                    return this.memberInfo.position ? this.memberInfo.position : '포지션'
                case PROFILE_BOX_LIST.SEX:
                    return this.memberInfo.sex + '성';
                case PROFILE_BOX_LIST.VISIT_REASONS:
                    return this.memberInfo[key];
                case PROFILE_BOX_LIST.HEIGHT:
                    return this.memberInfo[key] ? this.memberInfo[key] + 'cm' : '키';
                case PROFILE_BOX_LIST.FOOT_WAY:
                    return this.transFootWay();
                case PROFILE_BOX_LIST.SPECIAL_SKILL:
                    return this.memberInfo[key] ? this.memberInfo[key] : '개인기';
                case PROFILE_BOX_LIST.PLAY_STYLE:
                    return this.memberInfo[key] ? this.memberInfo[key] : '플레이 스타일';
                case PROFILE_BOX_LIST.PLACE_NAME:
                    return this.memberInfo[key] ? this.memberInfo[key] : '활동지역';
                case PROFILE_BOX_LIST.USE_REASONS:
                    return this.memberInfo[key] ? this.memberInfo[key] : '관심사';
                case PROFILE_BOX_LIST.DISPLAY_TAG:
                    return this.memberInfo[key] ? this.memberInfo[key] : '이용 목적';
                case PROFILE_BOX_LIST.LICENSE:
                    return this.memberInfo[key] ? this.memberInfo[key] : '지도자 등급'
                case PROFILE_BOX_LIST.CAREER:
                    return this.transCareer(this.memberInfo.career, this.memberInfo.level);
                case PROFILE_BOX_LIST.EXPERT_INFO:
                    return this.memberInfo[key] ? this.memberInfo[key] : '감독'
                default:
                    break;
            }
        },
        transCareer(career, level) {
            const result = level + ' / ' + career
            return result
        },
        getFootImage() {
            if (this.memberInfo.foot_way == PROFILE_FOOT_WAY.BOTH) {
                return require('@/assets/images/mypage/profile_box_foot_way_both.svg')
            } else if (this.memberInfo.foot_way == PROFILE_FOOT_WAY.LEFT) {
                return require('@/assets/images/mypage/profile_box_foot_way.svg')
            } else {
                return require('@/assets/images/mypage/profile_box_foot_way_right.svg')
            }
        },
        transFootWay() {
            if (this.memberInfo.foot_way === null) {
                return '사용하는 발'
            }
            if (this.memberInfo.foot_way == PROFILE_FOOT_WAY.BOTH) {
                return '양발'
            } else if (this.memberInfo.foot_way == PROFILE_FOOT_WAY.LEFT) {
                return '왼발'
            } else {
                return '오른발'
            }
        },
        showSelectPosition(isGoPosition = false) {
            if (!this.$Util.checkProfileCompleteOrShowRequiredProfile()) return;
            if (this.isCoach && !isGoPosition) {
                this.isOpenSettingPosition = true
            } else {
                this.$GlobalStore.addModal('SelectFindPosition', {});
                // this.$GlobalStore.addModal('FindPositionProMain', {});
            }
            // this.$GlobalStore.addModal('ProfileEdit')
        },
        async getMemberInfo() {
            const parameters = {};
            parameters.memberIdx = this.memberIdx;
            const res = await this.$Axios.get('/api/member/profile', { params: parameters });

            const memberInfo = res.data.member
            // const memberPlaceInfo = res.data.memberPlace
            // const memberStats = res.data.memberStats

            this.memberInfo = memberInfo
            if (this.memberInfo.is_temp_coach === '1') {
                // this.myProfileBoxList.push({ name: 'star', isComplete: false })
                this.myProfileBoxList = [
                    { name: PROFILE_BOX_LIST.EXPERT_INFO, isComplete: false },
                    { name: PROFILE_BOX_LIST.LICENSE, isComplete: false },
                    { name: PROFILE_BOX_LIST.PLACE_NAME, isComplete: false },
                    { name: PROFILE_BOX_LIST.POSITION, isComplete: false },
                    { name: PROFILE_BOX_LIST.USE_REASONS, isComplete: false },
                    { name: PROFILE_BOX_LIST.AGE_RANGE, isComplete: false },
                    { name: PROFILE_BOX_LIST.SEX, isComplete: false },
                ]
            }
            this.memberInfo.license = null
            // this.memberInfo.expert_info = null
            this.media = res.data.media;
            this.myPosition = this.$Util.transPosition(this.memberInfo.position)
            for (const key in this.myProfileBoxList) {
                if (this.memberInfo[this.myProfileBoxList[key].name] !== null) {
                    this.myProfileBoxList[key].isComplete = true
                    this.completeCount++
                }
            }
            this.settings.age_range = this.memberInfo.age_range_show == 1 ? true : false
            this.settings.sex = this.memberInfo.sex_show == 1 ? true : false
            setTimeout(() => {
                this.isShowBoxText = true
            }, 500);
        },
    },
    created() {
        this.apply = this.$Once(this.apply)
        this.saveProfileImage = this.$Once(this.saveProfileImage)
        this.getMemberInfo()
    }
}
</script>

<style scoped>
.alarm_container {
    background-color: #f5f5f5;
    border-radius: 12px;
    padding: 12px;
    display: flex;
}

.alarm_container_title {
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
}

.alarm_container_explanation {
    font-weight: 500;
    font-size: 12px;
    line-height: 20px;
}

.common_box {
    padding: 12px;
    border-radius: 12px;
    background-color: #f5f5f5;
}

.position_lite {
    background: linear-gradient(180deg, #FFDFCA 0%, #FFFFFF 131.62%);
}

.position_pro {
    background: linear-gradient(180deg, #1370AF 0%, #210F03 31.66%);
}

.profile_box {
    border-radius: 12px;
    background-color: #f5f5f5;
    /* height: 100px; */
    padding: 12px;
    padding-bottom: 14px;
    display: flex;
    align-items: center;
    position: relative;
    min-height: 110px;
    flex-direction: column;
    gap: 9px;
    justify-content: space-between;
    /* min-width: 110px; */
}

.profile_box_lite {
    background: linear-gradient(180deg, #FFDFCA 0%, #FDAE7B 100%);
}

.profile_box_pro {
    background: linear-gradient(180deg, #1370AF 0%, #210F03 31.66%);
}

.my_profile_box {
    min-width: 160px;
    max-width: 160px;
    height: 165px;
    padding: 12px 18px;
    background-color: #f5f5f5;
    border-radius: 12px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
}

.pro_background {
    background: linear-gradient(180deg, #1370AF 0%, #210F03 31.66%);
}

.pro_nicname {
    color: #fff;
}

.no_position_text {
    color: #808080
}

.common_btn {
    border-radius: 8px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    flex: 1;
    font-size: 14px
}

.common_btn.cancel {
    background-color: #ebebeb;
}

.common_btn.un_active {
    background-color: #f5f5f5;
    color: #d9d9d9;
}

.common_btn.active {
    background-color: #210F03;
    color: #fff;
}

.select {
    box-shadow: 0 0 0 2px #606060;
    border-radius: 50%;
}
</style>import SettingPositionVue from '../../common/SettingPosition.vue'
